import axios from "axios";
import {LINK} from "../../utils/Links";
import {SignInRequestJson} from "./interfaces";

export class SignInApi {

    static signIn = async (signInRequestJson: SignInRequestJson) => {
        try {
            const result = await axios.post(LINK.SIGNIN, signInRequestJson);
            return result.data;
        } catch (e) {
            throw e;
        }
    };

}